export function getGeneratedAnswerInitialState() {
    return {
        id: '',
        isVisible: true,
        isEnabled: true,
        isLoading: false,
        isStreaming: false,
        citations: [],
        liked: false,
        disliked: false,
        responseFormat: {
            contentFormat: ['text/plain'],
        },
        feedbackModalOpen: false,
        feedbackSubmitted: false,
        fieldsToIncludeInCitations: [],
        isAnswerGenerated: false,
        expanded: false,
        cannotAnswer: false,
    };
}
